import axios from "axios";

const PRODUCTION_MODE= true;

export const IP_Address = PRODUCTION_MODE ? "anpr-xpx1.onrender.com/" : "192.168.2.25:7001";

export const APIEND_POINT = `https://${IP_Address}/`;

const instance = axios.create({
  baseURL: APIEND_POINT,
  timeout: 1200000,
});

const apiCall = async ({
  method = "POST",
  url = "",
  params = {},
  data = {},
  timeout = 1200000,
  content_type = "application/json",
}) => {
  try {
    const headers = {
      Authorization: url == "/app/login/" ? null : `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-Type": content_type,
    };
    const options = { headers, timeout };
    const response = await instance({ method, url, params, data, ...options });

    if (response.status === 401 && url !== "/app/login/") {
      console.error(
        "Unauthorized access detected. Redirecting to login page..."
      );
      window.location.href = "/login";
    }
    return response;
  } catch (error) {
    let res = await error?.response
    if (res?.status === 401 && url !== "/app/login/") {
      console.error("Unauthorized access detected in error response. Redirecting to login page...");
      window.location.href = "/login";
    }
    return error?.response || {};
  }
};

export const APIUtility = {
  Login: (body) =>
    apiCall({
      method: "POST",
      url: "/app/login/",
      data: body,
    }),
  AddNewUser: (body) =>
    apiCall({
      method: "POST",
      url: "/app/create_user/",
      data: body,
    }),
  UpdateNewUser: (body) =>
    apiCall({
      method: "PUT",
      url: `/app/create_user/${body.id}/`,
      data: body,
    }),
  GetUser: (body) =>
    apiCall({
      method: "GET",
      url: "/app/create_user/",
      data: body,
    }),
  GetUserRole: (body) =>
    apiCall({
      method: "GET",
      url: "/app/get_user_role/",
      data: body,
    }),
  DeleteUser: (body) =>
    apiCall({
      method: "DELETE",
      url: `/app/create_user/${body.id}`,
      data: body,
    }),
  AddCamera: (body) =>
    apiCall({
      method: "POST",
      url: "/app/camera/",
      data: body,
    }),
  UpdateCamera: (body) =>
    apiCall({
      method: "PUT",
      url: `/app/camera/${body.id}/`,
      data: body,
    }),
  GetCameraData: (body) =>
    apiCall({
      method: "GET",
      url: "/app/camera/",
      data: body,
    }),
  DeleteCamera: (body) =>
    apiCall({
      method: "DELETE",
      url: `/app/camera/${body.id}`,
      data: body,
    }),
  AddNotificationConfig: (body) =>
    apiCall({
      method: "POST",
      url: "/base/alert_notifications/",
      data: body,
    }),
  GetNotificationConfig: (body) =>
    apiCall({
      method: "GET",
      url: "/base/alert_notifications/",
      data: body,
    }),
  UpdateNotificationConfig: (body) =>
    apiCall({
      method: "PUT",
      url: "/base/alert_notifications/",
      data: body,
    }),
  DeleteNotificationConfig: (body) =>
    apiCall({
      method: "DELETE",
      url: "/base/alert_notifications/",
      data: body,
    }),
  GetNotificationConfig: (body) =>
    apiCall({
      method: "GET",
      url: "/base/alert_notifications/",
      params: body,
    }),
  AddAlertNotificationMedia: (body) =>
    apiCall({
      method: "POST",
      url: "/base/alert_notifications_media/",
      data: body,
      content_type: "multipart/form-data",
    }),
  UpdateAlertNotificationMedia: (body) =>
    apiCall({
      method: "PUT",
      url: `/base/alert_notifications_media/`,
      data: body,
      content_type: "multipart/form-data",
    }),
  GetAlertNotificationMedia: (body) =>
    apiCall({
      method: "GET",
      url: "/base/alert_notifications_media/",
      data: body,
    }),
  DeleteAlertNotificationMedia: (body) =>
    apiCall({
      method: "DELETE",
      url: "/base/alert_notifications_media/",
      data: body,
    }),
  getThirdPartlink: (body) =>
    apiCall({
      method: "GET",
      url: "/base/third_part_links/",
      data: body,
    }),
  AddThirdPartlink: (body) =>
    apiCall({
      method: "POST",
      url: "/base/third_part_links/",
      data: body,
    }),
  UpdateThirdPartlink: (body) =>
    apiCall({
      method: "PUT",
      url: "/base/third_part_links/",
      data: body,
    }),
  boomBarrierImageSend: (body) =>
    apiCall({
      method: "POST",
      url: "/app/createqrdetails/",
      data: body,
      content_type: "multipart/form-data",
    }),
  ValidateImageSend: (body) =>
    apiCall({
      method: "POST",
      url: "/app/main_gate_validation/",
      data: body,
      content_type: "multipart/form-data",
    }),
  getVehicleEntriesData: (body) =>
    apiCall({
      method: "GET",
      url: "/app/createqrdetails/",
      params: body,
    }),
  GetQrCodeDetails: (body) =>
    apiCall({
      method: "GET",
      url: "/app/qrdetails/",
      params: body,
    }),
  GetVehicleDetails: (body) =>
    apiCall({
      method: "GET",
      url: "/app/vehicle_image/",
      params: body,
    }),
  getVehicleNoData: (body) =>
    apiCall({
      method: "POST",
      url: "/app/user_vehicle_list/",
      data: body,
    }),
  getVehicleEntryDetails: (body) =>
    apiCall({
      method: "GET",
      url: "/app/user_vehicle_list/",
      params: body,
    }),
  getUserRoles: (body) =>
    apiCall({
      method: "GET",
      url: "/app/roles/",
      params: body,
    }),
  getValidationMainGate: (body) =>
    apiCall({
      method: "GET",
      url: "/app/main_gate_validation/",
      params: body,
    }),
  addValidationMainGate: (body) =>
    apiCall({
      method: "POST",
      url: "/app/main_gate_validation/",
      data: body,
    }),
  adminRemark: (body) =>
    apiCall({
      method: "POST",
      url: "/app/admin_remarks/",
      data: body,
    }),
  printQRCode: (body) =>
    apiCall({
      method: "GET",
      url: "/app/print_qr/",
      params: body,
    }),
};
